var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "mx-auto row documents-container jumbo mt-3 p-3 bg-light d-flex align-items-center"
      },
      [
        _vm.proposalDocuments.length
          ? _c(
              "div",
              {
                staticStyle: { position: "absolute", "z-index": "1" },
                on: {
                  click: function($event) {
                    _vm.expanded = !_vm.expanded
                  }
                }
              },
              [
                _c("em", {
                  class: _vm.expanded
                    ? "far fa-chevron-circle-down color-green"
                    : "far fa-chevron-circle-right color-red"
                })
              ]
            )
          : _vm._e(),
        _c("div", { staticClass: "col-4 row mx-auto" }, [
          _c("label", { staticClass: "font-14 color-gray-6 col-12" }, [
            _vm._v("Documento:")
          ]),
          _c("label", { staticClass: "font-16 color-black col-12" }, [
            _vm._v(
              " " + _vm._s(_vm._f("empty")(_vm.item.documentTypeName)) + " "
            )
          ])
        ]),
        _c("div", { staticClass: "col-3 row mx-auto" }, [
          _vm.item.documentFilename
            ? _c("div", [
                _c("label", { staticClass: "font-14 color-gray-6 col-12" }, [
                  _vm._v("Archivo:")
                ]),
                _c("label", { staticClass: "font-16 color-black col-12" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("empty")(_vm.item.documentFilename)) +
                      " "
                  )
                ])
              ])
            : _vm._e()
        ]),
        _c("div", { staticClass: "col row mx-auto justify-content-end" }, [
          _vm.item.documentTypeId === _vm.documentTypes.PaymentCertificate
            ? _c(
                "div",
                {
                  staticClass:
                    "row col-12 row payment-upload justify-content-end"
                },
                [
                  !_vm.item.documentFilename
                    ? _c(
                        "div",
                        { staticClass: "row col-12 justify-content-end" },
                        [
                          _c("custom-file-input", {
                            ref: "paymentFileUpload",
                            staticClass: "custom-document-input col",
                            attrs: {
                              id: "paymentFileUpload",
                              accept: ".pdf",
                              "display-style": "normal",
                              "on-download": () => {}
                            },
                            on: {
                              input: function($event) {
                                return _vm.uploadDocument(
                                  _vm.item.documentTypeId
                                )
                              }
                            },
                            model: {
                              value: _vm.paymentfile,
                              callback: function($$v) {
                                _vm.paymentfile = $$v
                              },
                              expression: "paymentfile"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "row mx-auto col-12 justify-content-end"
                        },
                        [
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-download",
                              text: "Descargar",
                              variant: "success download-btn px-3"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onDownload(_vm.item.documentId)
                              }
                            }
                          }),
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-undo-alt",
                              text: "Reemplazar",
                              variant: "outline-success download-btn ml-3"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onReplaceDocument(
                                  _vm.item.documentTypeId
                                )
                              }
                            }
                          }),
                          _c("input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ],
                            ref: "paymentFileUploadHidden",
                            attrs: {
                              id: "paymentFileUploadHidden",
                              accept: ".pdf",
                              "attachment-id": _vm.item.documentId,
                              type: "file"
                            },
                            on: {
                              change: function($event) {
                                return _vm.updateFileChange(
                                  $event,
                                  _vm.item.documentTypeId
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                ]
              )
            : _vm._e(),
          _vm.item.documentTypeId === _vm.documentTypes.EvidencePaymentReceipt
            ? _c(
                "div",
                {
                  staticClass:
                    "col-12 row evidence-upload d-flex justify-content-end"
                },
                [
                  !_vm.item.documentFilename
                    ? _c(
                        "div",
                        {
                          staticClass: "row col-12 d-flex justify-content-end"
                        },
                        [
                          _c("custom-file-input", {
                            ref: "evidenceFileUpload",
                            staticClass: "custom-document-input col",
                            attrs: {
                              id: "evidenceFileUpload",
                              accept: ".pdf",
                              "display-style": "normal",
                              "on-download": () => {}
                            },
                            on: {
                              input: function($event) {
                                return _vm.uploadDocument(
                                  _vm.item.documentTypeId
                                )
                              }
                            },
                            model: {
                              value: _vm.evidencefile,
                              callback: function($$v) {
                                _vm.evidencefile = $$v
                              },
                              expression: "evidencefile"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "row mx-auto col-12 justify-content-end"
                        },
                        [
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-download",
                              text: "Descargar",
                              variant: "success download-btn px-3"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onDownload(_vm.item.documentId)
                              }
                            }
                          }),
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-undo-alt",
                              text: "Reemplazar",
                              variant: "outline-success download-btn ml-3"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onReplaceDocument(
                                  _vm.item.documentTypeId
                                )
                              }
                            }
                          }),
                          _c("input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ],
                            ref: "evidenceFileUploadHidden",
                            attrs: {
                              id: "evidenceFileUploadHidden",
                              accept: ".pdf",
                              type: "file"
                            },
                            on: {
                              change: function($event) {
                                return _vm.updateFileChange(
                                  $event,
                                  _vm.item.documentTypeId
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                ]
              )
            : _vm._e(),
          _vm.item.documentTypeId === _vm.documentTypes.CertificacionVisita
            ? _c(
                "div",
                { staticClass: "col-12 row d-flex justify-content-end" },
                [
                  !_vm.item.documentFilename
                    ? _c(
                        "div",
                        {
                          staticClass: "row col-12 d-flex justify-content-end"
                        },
                        [
                          _c("custom-file-input", {
                            ref: "visitCertification",
                            staticClass: "custom-document-input col",
                            attrs: {
                              id: "visitCertification",
                              accept: ".pdf",
                              "display-style": "normal",
                              "on-download": () => {}
                            },
                            on: {
                              input: function($event) {
                                return _vm.uploadDocument(
                                  _vm.item.documentTypeId
                                )
                              }
                            },
                            model: {
                              value: _vm.visitCertificationFile,
                              callback: function($$v) {
                                _vm.visitCertificationFile = $$v
                              },
                              expression: "visitCertificationFile"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "row mx-auto col-12 justify-content-end"
                        },
                        [
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-download",
                              text: "Descargar",
                              variant: "success download-btn px-3"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onDownload(_vm.item.documentId)
                              }
                            }
                          }),
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-undo-alt",
                              text: "Reemplazar",
                              variant: "outline-success download-btn ml-3"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onReplaceDocument(
                                  _vm.item.documentTypeId
                                )
                              }
                            }
                          }),
                          _c("input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ],
                            ref: "visitCertification",
                            attrs: {
                              id: "visitCertification",
                              accept: ".pdf",
                              type: "file"
                            },
                            on: {
                              change: function($event) {
                                return _vm.updateFileChange(
                                  $event,
                                  _vm.item.documentTypeId
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                ]
              )
            : _vm._e(),
          _vm.item.documentTypeId === _vm.documentTypes.Other
            ? _c(
                "div",
                { staticClass: "col-12 row d-flex justify-content-end" },
                [
                  !_vm.item.documentFilename
                    ? _c(
                        "div",
                        {
                          staticClass: "row col-12 d-flex justify-content-end"
                        },
                        [
                          _c("custom-file-input", {
                            ref: "otherFileUpload",
                            staticClass: "custom-document-input col",
                            attrs: {
                              id: "otherFileUpload",
                              accept: ".pdf",
                              "display-style": "normal",
                              "on-download": () => {}
                            },
                            on: {
                              input: function($event) {
                                return _vm.uploadDocument(
                                  _vm.item.documentTypeId
                                )
                              }
                            },
                            model: {
                              value: _vm.otherfile,
                              callback: function($$v) {
                                _vm.otherfile = $$v
                              },
                              expression: "otherfile"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "row mx-auto col-12 justify-content-end"
                        },
                        [
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-download",
                              text: "Descargar",
                              variant: "success download-btn px-3"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onDownload(_vm.item.documentId)
                              }
                            }
                          }),
                          _c("action-button", {
                            attrs: {
                              i: "fas fa-undo-alt",
                              text: "Reemplazar",
                              variant: "outline-success download-btn ml-3"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onReplaceDocument(
                                  _vm.item.documentTypeId
                                )
                              }
                            }
                          }),
                          _c("input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ],
                            ref: "otherFileUploadHidden",
                            attrs: {
                              id: "otherFileUploadHidden",
                              accept: ".pdf",
                              type: "file"
                            },
                            on: {
                              change: function($event) {
                                return _vm.updateFileChange(
                                  $event,
                                  _vm.item.documentTypeId
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                ]
              )
            : _vm.item.documentFilename && _vm.item.requestDocumentId === 0
            ? _c(
                "div",
                { staticClass: "col-12 row d-flex justify-content-end" },
                [
                  _c(
                    "div",
                    { staticClass: "row mx-auto col-12 justify-content-end" },
                    [
                      _c("action-button", {
                        staticClass:
                          "d-flex justify-content-center align-items-center",
                        attrs: { i: "fas fa-download p-1", variant: "success" },
                        on: {
                          click: function($event) {
                            return _vm.onDownload(_vm.item.documentId)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ])
      ]
    ),
    _vm.expanded
      ? _c(
          "div",
          { attrs: { id: "previous-proposal-document-container" } },
          _vm._l(_vm.proposalDocuments, function(subdoc) {
            return _c("div", { key: subdoc.documentId }, [
              _c("div", { staticClass: "row previous-proposal-item" }, [
                _c("div", { staticClass: "col" }, [
                  _vm._m(0, true),
                  _c("span", { staticClass: "font-16 color-black col-12" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("empty")(subdoc.documentFilename)) +
                        " "
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "col-2 mt-2 justify-content-end" },
                  [
                    _c("action-button", {
                      attrs: {
                        i: "fas fa-download",
                        text: "",
                        variant: "success download-btn px-3"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onDownload(subdoc.documentId)
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", { staticClass: "font-14 color-gray-6 col-12" }, [
        _vm._v("Archivo:")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }